function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import*as React from"react";import styled from"@emotion/styled";import{FlexLayout}from"@wp/src/components/common/grid";import PortfolioScoreHolder from"@wp/src/components/common/portfolioScoreHolder";import{Icon}from"@wp/src/components/common";export const ArrowContainer=styled.div`
  display: inline-flex;
  align-items: center;
  ${{"marginLeft":"1rem","marginRight":"1rem"}}
`;export const ArrowBar=styled.div`
  width: 60px;
  height: 3px;
  background: ${props=>props.theme.colors.neutral600};
  margin-right: -0.8rem;
`;export const RightArrow=props=>React.createElement(Icon,_extends({},props,{icon:"lucide:chevron-right",className:`text-icon stroke-[50px] text-xl ${props.className||""}`}));export const LeftArrow=props=>React.createElement(Icon,_extends({},props,{icon:"lucide:chevron-left",className:`text-icon stroke-[50px] text-xl ${props.className||""}`}));export const ColoredPortfolioScore=styled(PortfolioScoreHolder)`
  font-style: normal;
  text-align: center;
  width: initial;
  ${{"fontSize":"1.875rem","lineHeight":"2.25rem","fontWeight":"600"}}
`;export const MainScoreSectionContainer=styled.div`
  ${{"textAlign":"center"}}
`;export const PortfolioLabel=styled.div`
  ${{"fontSize":"0.875rem","lineHeight":"1.25rem","--tw-text-opacity":"1","color":"rgb(64 64 64 / var(--tw-text-opacity))"}}
`;export const ImpactContainer=styled(FlexLayout)``;export const MainScoreImpactRow=styled.div`
  ${{"display":"flex","alignItems":"center"}}
`;export const SubScoresImpactContainer=styled(FlexLayout)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  padding: 16px 20px 16px 0;
`;